(function () {
    'use strict';

	angular.module('app').filter('drawingWinnersFilter', function() {
		return function(input, query) {
			var out = [];
			
			if(query && query.length > 0) {
				var re = new RegExp(query.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"), 'i');
				// Using the angular.forEach method, go through the array of data and perform the operation of figuring out if the language is statically or dynamically typed.
				angular.forEach(input, function(obj) {
					if ( re.test(obj.email) || re.test(obj.description)) {
						out.push(obj)
					}
				});
			} else {
				out = input;
			}

			return out;
		}
	});
	
    angular.module('app').controller('DrawingWinnersEmailController', DrawingWinnersEmailController);

    DrawingWinnersEmailController.$inject = ['LaredoService', 'FlashService', '$scope', '$location', '$routeParams', '$rootScope', 'textAngularManager'];
    function DrawingWinnersEmailController(LaredoService, FlashService, $scope, $location, $routeParams, $rootScope, textAngularManager) {
        var ctrl = this;
		
		$scope.drawingWinnerEmail = {};
		$scope.drawingWinnersEmail = [];

		ctrl.platformOptions = $scope.platformOptions;
		
		ctrl.getDrawingWinnerEmails = function() {
			LaredoService.GetDrawingWinnersEmail()
				.then(function(drawingWinnersEmail) {
					$scope.drawingWinnersEmail = drawingWinnersEmail;
					console.log(drawingWinnersEmail);
				});
		};
		
		ctrl.editDrawingWinnersEmail = function (id) {
			// if(id) {
				// $scope.drawingWinnersEmail = {};
			// } else {
			// 	$scope.drawingWinnersEmail = {};
			// }
			
			$('#drawingWinnersEmailModal').modal();
		};


		ctrl.saveDrawingWinnerEmail = function () {
			LaredoService.SaveDrawingWinnersEmail($scope.drawingWinnerEmail).then(function(response) {
				if(!response.statusCode) {
					FlashService.Success(response.message, true);
					ctrl.getDrawingWinnerEmails();
					$('#drawingWinnersEmailModal').modal('hide');
				} else {
					FlashService.Error(response.message);
				}
			});
		};
		
		ctrl.deleteDrawingWinnerEmail = function (id) {
           	LaredoService.DeleteDrawingWinnersEmail(id).then(function(response) {
				if(!response.statusCode) {
					FlashService.Success(response.message, true);
                    ctrl.getDrawingWinnerEmails();
				} else {
					FlashService.Error( (response.message ? response.message : "An unexpected error occurred.  Please contact the Laredo help desk for assistance." ) );
					ctrl.dataLoading = false;
				}
			});
        };
		
		ctrl.getDrawingWinnerEmails();
    }
})();